
define('text!modules/targeting/pixel/templates/panel_layout.html',[],function () { return '<div class="column-A">\n  <div class="grid-holder" style="margin: 17px">{{#msgForProviderTax}} {{>info_box}} {{/msgForProviderTax}}</div>\n</div>\n<div class="bins-column"></div>\n';});

